import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { from, Observable } from 'rxjs';
import { AdvisorEntity } from '../../entities/advisor.entity';

@Injectable({
    providedIn: 'root',
})
export class AdvisorService extends BackendService {
    public getAdvisor(): Observable<AdvisorEntity | null> {
        const data = this.graphqlApi.query({
            fetchPolicy: 'network-only',
            query: gql`
            query {
                viewer {
                    advisor {
                        type
                        name
                        email
                        phone
                        mobilePhone
                        profilePictureUrl
                        onVacation
                        typeDescription
                        attendanceDescription
                        about {
                            title
                            content
                        }
                        whatsapp {
                            link
                            label
                        }
                        calendly {
                            link
                            label
                        }
                    }  
                }
            }
        `
        }).then(({ data }) => data.viewer.advisor ? new AdvisorEntity(data.viewer.advisor) : null
        ) as Promise<AdvisorEntity> | null;

        return from(data);
    }
}
